// @flow

import React from 'react';
import bemify from 'bemify-js';

import LogoImage from 'app/common/components/LogoImage';
import TruncatedText from 'app/common/components/TruncatedText';
import 'app/dashboard/components/AuthsList.scss';

const bem = bemify('auths-list');

type AuthsListItemProps = {
  selectedApi: string,
  title: string,
};

export type Auth = { id: number, ...$Exact<AuthsListItemProps> };

type AuthsListProps = {
  className?: string,
  auths: Array<Auth>,
};

const AuthsListItem = ({ selectedApi, title }: AuthsListItemProps) => {
  return (
    <li className={bem('__item')}>
      <LogoImage className={bem('__logo')} logoClass={selectedApi} />
      <TruncatedText block={true} className={bem('__title')}>
        {title}
      </TruncatedText>
    </li>
  );
};

const AuthsList = ({ auths, className }: AuthsListProps) => (
  <ul className={bem(className)}>
    {auths.map(auth => (
      <AuthsListItem
        key={auth.id}
        selectedApi={auth.selectedApi}
        title={auth.title}
      />
    ))}
  </ul>
);

export default AuthsList;
